export const DEFAULT_CURRENCY = 'USD';
export const ACCOMMODATION = 'accommodation';
export const VEHICLE = 'vehicle';
